// src/api/speakerApi.js
import { speakerMockData } from "./mock/speakerData";

export const getDataByAll = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(speakerMockData);
    }, 600);
  });
};